import {Component, HostListener, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {ApplicationService} from '../../../services/application.service';
import {Application} from '../../../domain/onBoarding/application';
import {EDocType} from '../../../enums/EDocType';
import {merge, Observable, Subject} from 'rxjs';
import {CommonComponent} from '../../shared/common/common.component';
import {NgbModal, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {NotificationsService} from '../../../services/notifications.service';
import {IId} from '../../../domain/onBoarding/IId';
import {CatalogsService} from '../../../services/catalogs.service';
import {ApplicationBody} from '../../../domain/onBoarding/application-body';
import {ApplicationEntity} from '../../../entity/ApplicationEntity';
import {ToastaService} from 'ngx-toasta';
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {ICountry} from '../../../domain/ICountry';
import {debounceTime, distinctUntilChanged, filter, map} from 'rxjs/operators';
import {IGeneric} from '../../../domain/IGeneric';
import {EKycStatus} from '../../../enums/EKycStatus';
import {DialogService} from 'primeng/dynamicdialog';
import {ConfigurationService} from '../../../services/configuration.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-photos',
  templateUrl: './photos.component.html',
  styleUrls: ['./photos.component.scss']
})
export class PhotosComponent extends CommonComponent implements OnInit {

  @ViewChild('modal_instantApproval', {static: true}) templateRef: TemplateRef<any>;

  webcamImage: WebcamImage = null;
  application: Application;
  docCatalog1: IId[] = [];
  docCatalog2: IId[] = [];
  id1: IId = undefined;
  id2: IId = undefined;
  docTypes = EDocType;
  photoType: any;
  appStatus: string;

  public showWebcam = true;
  public allowCameraSwitch = true;
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public cameraPerms = true;
  public errors: WebcamInitError[] = [];
  public innerWidth: any;

  private trigger: Subject<void> = new Subject<void>();
  private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

  id1FrontFileValue: File = null;
  id1BackFileValue: File = null;
  id2FrontFileValue: File = null;
  id2BackFileValue: File = null;
  lang: string;

  countries: ICountry[];
  selectedCountry: ICountry;
  selectedCountry2: ICountry;
  selectedCountryPrevious: ICountry;
  selectedCountry2Previous: ICountry;

  @ViewChild('instanceIdentificationCountry') identificationCountry: NgbTypeahead;
  @ViewChild('instanceIdentificationCountry2') identificationCountry2: NgbTypeahead;
  focusIdentificationCountry$ = new Subject<string>();
  clickIdentificationCountry$ = new Subject<string>();
  focusIdentificationCountry2$ = new Subject<string>();
  clickIdentificationCountry2$ = new Subject<string>();

  hasIdFront1 = false;
  hasIdFront2 = false;
  hasIdBack1 = false;
  hasIdBack2 = false;

  disableCountry2 = false;

  previewId = "";

  front1isPDF = false;
  back1isPDF = false;
  front2isPDF = false;
  back2isPDF = false;

  selectSize1: number = 1;
  selectSize2: number = 1;
  onSelect = false;
  onSelect2 = false;

  @HostListener('window:resize', ['$event'])
  onResize(event?: Event) {
    const win = !!event ? (event.target as Window) : window;
    this.innerWidth = win.innerWidth;
  }

  constructor(
    protected router: Router,
    private catalogsService: CatalogsService,
    private applicationService: ApplicationService,
    protected modalService: NgbModal,
    protected notificationsService: NotificationsService,
    protected toastService: ToastaService,
    public translate: TranslateService,
    protected dialogService: DialogService,
    public configurationService: ConfigurationService,
    private sanitizer: DomSanitizer
  ) {
    super(modalService, notificationsService, toastService, router, translate, dialogService);
    this.application = applicationService.application;
    this.onResize();
    this.lang = translate.currentLang;
    translate.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.lang = translate.currentLang;
        this.getCountriesCatalog();
      });
  }

  ngOnInit() {
    scroll(0, 0);
    if (!this.application || !this.application.editing) {
      this.router.navigate(['/onboarding/']);
      return;
    }
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
      });
    this.getCountriesCatalog();
    this.appStatus = this.application.body.status;
    if (!this.application.body.driverLicenseNumber && !this.application.body.socialSecurityNumber) {
      this.openModal(this.templateRef);
    }
    if (this.application.body.documents) {
      for (const doc of this.application.body.documents) {
        switch (doc) {
          case 'IDENTIFICATION_FRONT':
            this.hasIdFront1 = true;
            break;
          case 'IDENTIFICATION2_FRONT':
            this.hasIdFront2 = true;
            break;
          case 'IDENTIFICATION_BACK':
            this.hasIdBack1 = true;
            break;
          case 'IDENTIFICATION2_BACK':
            this.hasIdBack2 = true;
            break;
        }
      }
    }
    this.hasIdFront1 ||= this.application.identificationFront != null;
    this.hasIdBack1 ||= this.application.identificationBack != null;
    this.hasIdFront2 ||= this.application.identification2Front != null;
    this.hasIdBack2 ||= this.application.identification2Back != null;

  }

  getCountriesCatalog() {
    this.catalogsService.getIdentificationContryCatalog(this.application.body.agentMode).subscribe(
      (response: any) => {
        this.countries = response;
        if (this.application.body.identificationCountry) {
          this.selectedCountry = this.countries.find(it => this.application.body.identificationCountry == it.id);
          if (this.selectedCountry) {
            this.getIds1();
          }
        }
        if (this.application.body.identification2Country) {
          this.selectedCountry2 = this.countries.find(it => this.application.body.identification2Country == it.id);
          if (this.selectedCountry2) {
            if (this.selectedCountry2.id !== 'OTHER' && this.selectedCountry2.id !== 'UNITED_STATES'
              && this.selectedCountry2.id === this.application.body.identificationCountry){
              this.disableCountry2 = true;
            }
            this.getIds2();
          }
        }
      }, error => {
        this.msgError(error);
      }
    );
  }

  handleImage(webcamImage: WebcamImage) {
    this.webcamImage = webcamImage;
    switch (this.photoType) {
      case EDocType.IDENTIFICATION_FRONT:
        this.application.identificationFront = webcamImage.imageAsDataUrl;
        this.application.sendIdentificationFront = true;
        this.application.uploadedId1Front = false;
        this.id1FrontFileValue = null;
        this.hasIdFront1 = true;
        this.front1isPDF = false;
        break;
      case EDocType.IDENTIFICATION_BACK:
        this.application.identificationBack = webcamImage.imageAsDataUrl;
        this.application.sendIdentificationBack = true;
        this.application.uploadedId1Back = false;
        this.id1BackFileValue = null;
        this.hasIdBack1 = true;
        this.back1isPDF = false;
        break;
      case EDocType.IDENTIFICATION2_FRONT:
        this.application.identification2Front = webcamImage.imageAsDataUrl;
        this.application.sendIdentification2Front = true;
        this.application.uploadedId2Front = false;
        this.id2FrontFileValue = null;
        this.hasIdFront2 = true;
        this.front2isPDF = false;
        break;
      case EDocType.IDENTIFICATION2_BACK:
        this.application.identification2Back = webcamImage.imageAsDataUrl;
        this.application.sendIdentification2Back = true;
        this.application.uploadedId2Back = false;
        this.id2BackFileValue = null;
        this.hasIdBack2 = true;
        this.back2isPDF = false;
        break;
      default:
        break;
    }
  }

  public triggerSnapshot(modal: any): void {
    this.trigger.next();
    modal.close();
  }

  onSubmit() {
    this.loadingModalOn();
    this.applicationService.setApplication(false, true, false).subscribe(
      (response: ApplicationBody) => {
        if (!this.application.body.applicationId) {
          this.application.body.applicationId = response.applicationId;
        }
        this.application.sendIdentificationFront = false;
        this.application.sendIdentificationBack = false;
        this.application.sendIdentification2Front = false;
        this.application.sendIdentification2Back = false;
        this.setOcrData(response);
        this.loadingModalOff();
        this.application.body.status = response.status;
        this.application.body.kycStatus = response.kycStatus;
        this.router.navigate(['/onboarding/selfie']);
      },
      error => {
        this.loadingModalOff();
        this.msgError(error);
        if (error.error.code === '4600') {
          this.applicationService.application = new ApplicationEntity();
          this.router.navigate(['/']);
        }
      }
    );
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public handleInitError(error: WebcamInitError): void {
    this.errors.push(error);
    this.msgError(error, this.translate.instant('onboarding.photos.cameraUsageDenied', {Default: 'Es necesario que permita el uso de su cámara web. Por favor, brinde autorización y recargue la página.'}));
    this.cameraPerms = false;
  }

  public showNextWebcam(directionOrDeviceId: boolean | string): void {
    this.nextWebcam.next(directionOrDeviceId);
  }

  public cameraWasSwitched(deviceId: string): void {
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean | string> {
    return this.nextWebcam.asObservable();
  }

  getIds1() {
    this.catalogsService.getIdentificationCatalog(1, this.selectedCountry.numericCode, null, this.application.body.agentMode).subscribe(
      (response: any) => {
        this.docCatalog1 = response;
        this.docCatalog1 = this.docCatalog1.map(item => {
          if (item.numericCode === this.selectedCountry.numericCode) {
            item.value = item.value + ' (' + this.selectedCountry.value + ')';
          }
          return item;
        });
        this.id1 = this.docCatalog1.find((item) => item.id === this.application.body.identificationType);
      }, error => {
        this.msgError(error);
      }
    );
  }

  getIds2() {
    this.catalogsService.getIdentificationCatalog(2, this.selectedCountry2.numericCode, this.application.body.identificationType, this.application.body.agentMode).subscribe(
      (response: any) => {
        this.docCatalog2 = response;
        this.docCatalog2 = this.docCatalog2.map(item => {
          if (item.numericCode === this.selectedCountry2.numericCode) {
            item.value = item.value + ' (' + this.selectedCountry2.value + ')';
          }
          return item;
        });
        this.id2 = this.docCatalog2.find((item) => item.id === this.application.body.identification2Type);
      }, error => {
        this.msgError(error);
      }
    );
  }

  onOptionSelect(selectName: string): void {
    const SELECTOR_ITEM = document.querySelector(`select[name="${selectName}"]`) as HTMLSelectElement;
    if (SELECTOR_ITEM) {
      SELECTOR_ITEM.blur();
    }
  }

  onFirstIdChange() {
    if (this.application.body.identificationType === 'PERSONAL_IDENTIFICATION_DOCUMENT_DPI'){
      this.application.body.identificationNumber = null;
    }
    this.application.body.identificationType = this.id1?.id;
    if (this.application.identificationFront !== null || this.application.identificationBack !== null) {
      this.application.uploadedId1Back = false;
      this.application.uploadedId1Front = false;
      this.application.identificationFront = null;
      this.application.identificationBack = null;
      this.application.sendIdentificationFront = false;
      this.application.sendIdentificationBack = false;
      this.id1FrontFileValue = null;
      this.id1BackFileValue = null;
      this.hasIdFront1 = false;
      this.hasIdBack1 = false;
      this.resetDocument(1);
    }
    if (this.selectedCountry2) {
      this.getIds2();
    }
  }

  onSecondIdChange() {
    if (this.application.body.identification2Type === 'PERSONAL_IDENTIFICATION_DOCUMENT_DPI'){
      this.application.body.identificationNumber = null;
    }
    this.application.body.identification2Type = this.id2?.id;
    if (this.application.identification2Front !== null || this.application.identification2Back !== null) {
      this.application.uploadedId2Back = false;
      this.application.uploadedId2Front = false;
      this.application.identification2Front = null;
      this.application.identification2Back = null;
      this.application.sendIdentification2Front = false;
      this.application.sendIdentification2Back = false;
      this.id2FrontFileValue = null;
      this.id2BackFileValue = null;
      this.hasIdFront2 = false;
      this.hasIdBack2 = false;
      this.resetDocument(2);
    }
  }

  resetDocument(section: number) {
      if (this.application.body.documents) {
        switch (section){
          case 1:
            delete this.application.body.documents[this.application.body.documents.indexOf(EDocType.IDENTIFICATION_FRONT)];
            delete this.application.body.documents[this.application.body.documents.indexOf(EDocType.IDENTIFICATION_BACK)];
            break;
          case 2:
            delete this.application.body.documents[this.application.body.documents.indexOf(EDocType.IDENTIFICATION2_FRONT)];
            delete this.application.body.documents[this.application.body.documents.indexOf(EDocType.IDENTIFICATION2_BACK)];
            break;
        }
      }
  }

  invalidPhotos(): boolean {
    if (this.id1 == null || !this.hasIdFront1 || (this.id1.bothSides && !this.hasIdBack1)) {
      return true;
    }
    if (this.id2 == null || !this.hasIdFront2 || (this.id2.bothSides && !this.hasIdBack2)) {
      return true;
    }
    return false;
  }

  openPhotoModal(content: TemplateRef<any>, doctype?: EDocType): void {
    // this.photoType = doctype;
    this.modalService.open(content, {
      size: 'lg',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  changeFile(idFile, fileType: string, dismiss?: Function) {
    const file = idFile.files[0];

    if (file) {
      if (file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
        if (file.size > 2621440) {
          this.msgWarning(this.translate.instant('onboarding.photos.invalidSize', { Default: 'El tamaño del archivo excede el máximo permitido (2.5 MB)' }));
        } else {

          if (file.type === 'image/png' || file.type === 'image/jpeg' || file.type === 'image/jpg') {
            switch (fileType) {
              case EDocType.IDENTIFICATION_FRONT:
                this.application.identificationFront = file;
                this.application.sendIdentificationFront = true;
                this.application.uploadedId1Front = true;
                this.hasIdFront1 = true;
                this.id1FrontFileValue = null;
                this.front1isPDF = false;
                break;
              case EDocType.IDENTIFICATION_BACK:
                this.application.identificationBack = file;
                this.application.sendIdentificationBack = true;
                this.application.uploadedId1Back = true;
                this.hasIdBack1 = true;
                this.id1BackFileValue = null;
                this.back1isPDF = false;
                break;
              case EDocType.IDENTIFICATION2_FRONT:
                this.application.identification2Front = file;
                this.application.sendIdentification2Front = true;
                this.application.uploadedId2Front = true;
                this.hasIdFront2 = true;
                this.id2FrontFileValue = null;
                this.front2isPDF = false;
                break;
              case EDocType.IDENTIFICATION2_BACK:
                this.application.identification2Back = file;
                this.application.sendIdentification2Back = true;
                this.application.uploadedId2Back = true;
                this.hasIdBack2 = true;
                this.id2BackFileValue = null;
                this.back2isPDF = false;
                break;
              default:
                this.msgWarning(this.translate.instant('onboarding.photos.invalidFile', { Default: 'El formato del archivo es inválido. Debe ser JPG, JPEG, PNG o PDF.' }));
                break;
            }
          }

          if (file.type === 'application/pdf') {

            switch (fileType) {
              case EDocType.IDENTIFICATION_FRONT:
                this.application.identificationFront = file;
                this.application.sendIdentificationFront = true;
                this.application.uploadedId1Front = true;
                this.hasIdFront1 = true;
                this.id1FrontFileValue = null;
                this.front1isPDF = true;
                break;

              case EDocType.IDENTIFICATION_BACK:
                this.application.identificationBack = file;
                this.application.sendIdentificationBack = true;
                this.application.uploadedId1Back = true;
                this.hasIdBack1 = true;
                this.id1BackFileValue = null;
                this.back1isPDF = true;
                break;
              case EDocType.IDENTIFICATION2_FRONT:
                this.application.identification2Front = file;
                this.application.sendIdentification2Front = true;
                this.application.uploadedId2Front = true;
                this.hasIdFront2 = true;
                this.id2FrontFileValue = null;
                this.front2isPDF = true;
                break;
              case EDocType.IDENTIFICATION2_BACK:
                this.application.identification2Back = file;
                this.application.sendIdentification2Back = true;
                this.application.uploadedId2Back = true;
                this.hasIdBack2 = true;
                this.id2BackFileValue = null;
                this.back2isPDF = true;
                break;
              default:
                this.msgWarning(this.translate.instant('onboarding.photos.invalidFile', { Default: 'El formato del archivo es inválido. Debe ser JPG, JPEG, PNG o PDF.' }));
                break;
            }
          }

          if (dismiss) {
            dismiss();
          }
        }
      }
    } else {

      switch (fileType) {
        case EDocType.IDENTIFICATION_FRONT:
          this.application.identificationFront = null;
          this.hasIdFront1 = false;
          break;
        case EDocType.IDENTIFICATION_BACK:
          this.application.identificationBack = null;
          this.hasIdBack1 = false;
          break;
        case EDocType.IDENTIFICATION2_FRONT:
          this.application.identification2Front = null;
          this.hasIdFront2 = false;
          break;
        case EDocType.IDENTIFICATION2_BACK:
          this.application.identification2Back = null;
          this.hasIdBack2 = false;
          break;
        default:
          break;
      }

      this.msgWarning(this.translate.instant('onboarding.photos.invalidFile', { Default: 'El formato del archivo es inválido. Debe ser JPG, JPEG o PNG.' }));
    }
  }

  pdfUrl(file: File): any {
    return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(file));
  }

  searchIdentificationCountry = (text$: Observable<string>): Observable<ICountry[]> => {
    const debouncedText$ = text$.pipe(debounceTime(1), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.clickIdentificationCountry$.pipe(filter(() => !this.identificationCountry.isPopupOpen()));
    const inputFocus$ = this.focusIdentificationCountry$;
    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => term.length < 1 ? this.countries : this.countries.filter(v => v.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(term.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) > -1).slice(0, 10)
      ));
  }

  searchIdentificationCountry2 = (text$: Observable<string>): Observable<ICountry[]> => {
    const debouncedText$ = text$.pipe(debounceTime(1), distinctUntilChanged());
    const clicksWithClosedPopup$ = this.clickIdentificationCountry2$.pipe(filter(() => !this.identificationCountry2.isPopupOpen()));
    const inputFocus$ = this.focusIdentificationCountry2$;
    return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(
      map(term => term.length < 1 ? this.countries : this.countries.filter(v => v.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().indexOf(term.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()) > -1).slice(0, 10)
      ));
  }

  itemToString(item: IGeneric): string {
    return item.value;
  }

  onFocus1() {
    this.selectedCountry = null;
  }

  onBlur1() {
    this.selectedCountry = this.selectedCountryPrevious;
  }

  onFocus2() {
    this.selectedCountry2 = null;
  }

  onBlur2() {
    this.selectedCountry2 = this.selectedCountry2Previous;
  }

  assignCountry() {
    if (this.selectedCountry.id === 'OTHER' || this.selectedCountry.id === 'UNITED_STATES'){
      this.disableCountry2 = false;
    } else {
      this.disableCountry2 = true;
      if (this.selectedCountry.id !== this.application.body.identification2Country){
        this.selectedCountry2 = this.selectedCountry;
        this.assignCountry2();
      }
    }
    // Condition to reset documents to null if the user change de Country
    this.application.identificationFront = null;
    this.application.identificationBack = null;
    this.application.sendIdentificationFront = false;
    this.application.sendIdentificationBack = false;
    this.application.uploadedId1Back = false;
    this.application.uploadedId1Front = false;
    // End of condition

    this.selectedCountryPrevious = this.selectedCountry;
    this.application.body.identificationCountry = this.selectedCountry.id;
    this.application.body.identificationNumber = null;
    this.application.body.identificationType = null;
    this.id1 = undefined;
    this.hasIdFront1 = this.hasIdBack1 = false;
    this.resetDocument(1);
    this.getIds1();
  }

  assignCountry2() {
    if (this.application.body.identification2Type === 'PERSONAL_IDENTIFICATION_DOCUMENT_DPI'){
      this.application.body.identificationNumber = null;
    }
    this.application.uploadedId2Front = false;
    this.application.uploadedId2Back = false;
    this.application.identification2Front = null;
    this.application.identification2Back = null;
    this.application.sendIdentification2Front = false;
    this.application.sendIdentification2Back = false;
    this.selectedCountry2Previous = this.selectedCountry2;
    this.application.body.identification2Country = this.selectedCountry2.id;
    this.application.body.identification2Type = null;
    this.id2 = undefined;
    this.hasIdFront2 = this.hasIdBack2 = false;
    this.resetDocument(2);
    this.getIds2();
  }

  onBack() {
    if (this.application.body.kycStatus == EKycStatus.PENDING_DOCUMENTS) {
      this.application.cipQ ? this.application.cipQ = false : this.application.cipQ;
      this.router.navigate(['/onboarding/personalData']);
    } else {
      this.router.navigate(['/onboarding/usaIds']);
    }
  }

  onBackUsaIDs() {
    this.application.ssnOrDL = false;
    this.router.navigate(['/onboarding/usaIds']);
  }

  openModal(content: TemplateRef<any>): void {
    this.modalService.open(content, {
      size: 'md',
      centered: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  setOcrData(applicationBody: ApplicationBody){
    // OCR Data, a todos los de OCR
    if ( applicationBody.ocrFirstName || applicationBody.ocrAdditionalNames || applicationBody.ocrLastName
      || applicationBody.ocrSecondLastName || applicationBody.ocrGender || applicationBody.ocrDateOfBirth
      || applicationBody.ocrBirthplaceName || applicationBody.ocrBirthplace){
      this.application.body.ocrFirstName = applicationBody.ocrFirstName;
      this.application.body.ocrAdditionalNames = applicationBody.ocrAdditionalNames;
      this.application.body.ocrLastName = applicationBody.ocrLastName;
      this.application.body.ocrSecondLastName = applicationBody.ocrSecondLastName;
      this.application.body.ocrGender = applicationBody.ocrGender;
      this.application.body.ocrDateOfBirth = applicationBody.ocrDateOfBirth;
      this.application.body.ocrBirthplaceName = applicationBody.ocrBirthplaceName;
      this.application.body.ocrBirthplace = applicationBody.ocrBirthplace;
      this.application.body.ocrFieldsConfirm = applicationBody.ocrFieldsConfirm;
    }
  }
  isMexican(): boolean{
    if (this.application.identificationFront) {
      if (this.application.body.identificationCountry === 'MEXICO'){
        return true;
      }
    }
    if (this.application.identification2Front) {
      if (this.application.body.identification2Country === 'MEXICO'){
        return true;
      }
    }
    return false;
  }
}
